import * as React from 'react';
import { cn } from '@/lib/cn';

/**
 * Native `<select>` rather than a listbox widget.
 *
 * WCAG 2.2 AA is a floor, not a ceiling: the native control already has
 * correct keyboard semantics on every platform, including mobile, where §22.5
 * requires the filter to stay usable.
 */
export function Select({ className, ...props }: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={cn(
        'h-9 rounded-md border border-input bg-background px-3 py-1 text-sm ' +
          'disabled:cursor-not-allowed disabled:opacity-50 ' +
          'aria-disabled:cursor-not-allowed aria-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
